import { render, staticRenderFns } from "./TagBasic.vue?vue&type=template&id=5ae35550&scoped=true"
import script from "./TagBasic.vue?vue&type=script&lang=js"
export * from "./TagBasic.vue?vue&type=script&lang=js"
import style0 from "./TagBasic.vue?vue&type=style&index=0&id=5ae35550&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ae35550",
  null
  
)

export default component.exports